/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { VisionApplication, formatDateTimeZone } from '../../application';
import { VisionFleetTab } from './fleet';
import { VisionFleetService } from './service';

export class NonReportingVehicleTab {
    grid!: dhtmlXGridObject;
    toolbar!: dhtmlXToolbarObject;

    service: VisionFleetService;
    loaded: boolean;

    constructor(tab: VisionFleetTab) {
        this.service = tab.service;
        this.loaded = false;
        tab.dataTabbar.addTab('non-reporting', 'Non Reporting', 150, 2, false, false);

        this.toolbar = tab.dataTabbar.cells('non-reporting').attachToolbar();
        this.toolbar.addButton('export_xls', 1, 'Excel', 'icons/excel.png', '');
        this.toolbar.addButton('export_pdf', 2, 'PDF', 'icons/pdf.png', '');

        this.grid = tab.dataTabbar.cells('non-reporting').attachGrid();
        this.grid.setHeader('Asset,Last Seen,Days,Description', ',', ['text-align:left;', 'text-align:center;', 'text-align:center;', 'text-align:center;']);
        this.grid.setColTypes('ro,ro,ro,ro');
        this.grid.setColSorting('str,int,int,str');
        this.grid.setColAlign('left,center,center,center');
        this.grid.init();

        this.toolbar.attachEvent('onClick', (id) => {
            this.generateReport(id);
        });
    }

    private generateReport(format: string) {
        if (format == 'export_pdf') {
            this.service.downloadPDF('/fleet/report/nonreporting?format=pdf', `report_${Date.now()}.pdf`);
        } else if (format == 'export_xls') {
            this.service.downloadXLSX('/fleet/report/nonreporting?format=xlsx', `report_${Date.now()}.xlsx`);
        }
    }

    public update() {
        this.loaded = true;
        this.grid.clearAll(false);
        this.service.getNonReportingVehicles().then((data) => {
            data.parsedBody?.forEach((item) => {
                const asset = VisionApplication.getInstance().assetService.assetList.get(item.id);
                if (asset) {
                    const diffMs = Math.abs(Date.now() - item.lastSeen);
                    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

                    const lastSeen = formatDateTimeZone(item.lastSeen, 'America/New_York');
                    this.grid.addRow(item.id, [asset.id.name, lastSeen, diffDays, asset.description], 0, 0, '', false);
                }
            });
            this.grid.sortRows(2, 'int', 'desc');
        });
    }
}
